import type { FC, ReactNode } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbLinkProps,
} from '@chakra-ui/react';
import { QBox } from '../../QLayouts';
import { QLink, QLinkProps } from '../../QAtoms';
import { QIcon } from '../../QIcons';
import { usePartitionedChildren } from '../../utils';

export type QBreadcrumbItemProps = {
  to: string;
  children?: ReactNode;
} & Pick<BreadcrumbLinkProps, 'isCurrentPage'> &
  Pick<QLinkProps, 'isCrossMFE'>;

export const QBreadcrumb: FC<{ children?: ReactNode }> & {
  Item: FC<QBreadcrumbItemProps>;
} = ({ children }) => {
  const { QBreadcrumbItem: crumbs } = usePartitionedChildren(
    children,
    'QBreadcrumbItem',
  );
  return (
    <Breadcrumb separator={<Separator />} spacing="2px">
      {crumbs.map((c) => {
        const props = c.props as QBreadcrumbItemProps;
        return (
          <BreadcrumbItem key={props.to}>
            <BreadcrumbLink as={QLink} href={props.to} {...props} />
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

QBreadcrumb.displayName = 'QBreadcrumb';

QBreadcrumb.Item = ({ children, ...rest }) => (
  <BreadcrumbItem>
    <BreadcrumbLink as={QLink} {...rest}>
      {children}
    </BreadcrumbLink>
  </BreadcrumbItem>
);

QBreadcrumb.Item.displayName = 'QBreadcrumbItem';

const Separator: FC = () => (
  <QBox paddingTop="6px">
    <QIcon iconName="ChevronRight" />
  </QBox>
);
